import React, { useContext } from 'react';
import { Button, MenuItem, Select, TextField, FormControl, InputLabel, InputAdornment, Input } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import styles from './index.module.scss';
import Title from '../Title';
import SectionTitle from '../SectionTitle';
import ContactItem from '../ContactItem';
import AdvanceMenuContext from '../../contexts/advance-menu-context';

const EventForm = () => {
    const mockContacts = [
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
        {
            initial: "A",
            name: "Andy B",
            title: "Product Owner"
        },
    ];

    const { setShowMenu } = useContext(AdvanceMenuContext);

    const onClickPost = () => {
        setShowMenu(false);
    }

    return (
        <div className={styles.container}>
            <Title title="Post an Event" 
                   subtitle="Communicate with your stakeholders on progress, milestone, decisions, etc" />
            
            <FormControl variant="outlined" className={styles.eventInput}>
                <InputLabel id="event-label">Event</InputLabel>
                <Select labelId="event-label" label="event">
                    <MenuItem value="Milestone">Milestone</MenuItem>
                </Select>
            </FormControl>

            <SectionTitle title="Content"/>
            <div className={styles.inputItem}>
                <TextField label="Title"
                        variant="outlined" />
            </div>
            <div className={styles.inputItem}>
                <TextField label="Message"
                           multiline
                           rowsMax={3}
                           rows={3}
                           variant="outlined" />
            </div>

            <SectionTitle title="Publish To"/>

            <FormControl fullWidth className={styles.publishSearch}>
                <Input placeholder="Search for Contact/Group"
                       startAdornment={
                            <InputAdornment position="start">
                                <SearchIcon></SearchIcon>
                            </InputAdornment>} />
            </FormControl>

            <div className={styles.contactList}>
                {mockContacts.map((contact, i) => <ContactItem contact={contact} />)}
            </div>

            <div className={styles.actions}>
                <Button variant="contained" color="primary" onClick={onClickPost}>Post</Button>
            </div>
        </div>
    )
};

export default EventForm;
